import { IReturnDelivery } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { MessagePayloadType } from 'src/app/shared/models/share/message-payload-type';

import { IRouteParser } from '../contracts/route/route-parser';
import { QueryService } from '../query/query.service';
import { ReturnDeliveryDB } from 'src/app/common/repository/databases';
import { MessagePayloadReturnDelivery } from '../../models/share/message-payload-return-delivery';

@Injectable()
export class ReturnDeliveryRouteParser implements IRouteParser {
  type = MessagePayloadType.ReturnDelivery;

  constructor(private _queryService: QueryService) {}
  async parse(payload: MessagePayloadReturnDelivery): Promise<string> {
    const returnDelivery: IReturnDelivery = await this._queryService.get(payload.returnDeliveryId, ReturnDeliveryDB);

    if (!returnDelivery) {
      throw new Error(`No return delivery found for id ${payload.returnDeliveryId}`);
    } else {
      return `/patient/${returnDelivery.patientId}/careproposal/returndelivery/${returnDelivery._id}`;
    }
  }
}
